import type { IAuthorization } from '~/types/authorization'

import config from '~/config'
import { DEFAULT_ITEMS_PER_PAGE_VALUE } from '~/const'
import { request } from '~/utils/request'

export const createAuthorizations = (
  authorizations: { action: string; description: string; resource: string; service: string }[]
): Promise<IAuthorization[]> => {
  return request({
    data: authorizations,
    method: 'POST',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/authorization`,
  })
}

export const getAuthorizations = (): Promise<IPaginatedResponse<IAuthorization>> => {
  return request({
    params: {
      size: DEFAULT_ITEMS_PER_PAGE_VALUE,
    },
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/authorization/search`,
  })
}

export const getAuthorization = (authorizationKey: string): Promise<IAuthorization> => {
  return request({
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/authorization/${authorizationKey}`,
  })
}

export const updateAuthorization = (auth: { authorizationKey: string; description?: string }): Promise<void> => {
  return request({
    data: { description: auth.description },
    method: 'PUT',
    url: `${config.ADMIN_AUTHORIZATION_API}/iam/authorization/${auth.authorizationKey}`,
  })
}
